import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";

interface EditExerciseDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  exerciseName: string;
  onExerciseNameChange: (value: string) => void;
  onSave: () => void;
  exercise?: any; // Added this prop
}

export const EditExerciseDialog = ({
  isOpen,
  onOpenChange,
  exerciseName,
  onExerciseNameChange,
  onSave,
}: EditExerciseDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="w-[95%] max-w-md mx-auto bg-clubbers-gray border-white/20 p-4 sm:p-6">
        <DialogHeader>
          <DialogTitle className="text-lg sm:text-xl">Editar Ejercicio</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <Input
            value={exerciseName}
            onChange={(e) => onExerciseNameChange(e.target.value)}
            placeholder="Nombre del ejercicio"
            className="bg-white/10 border-white/20 text-white"
          />
        </div>
        <DialogFooter className="sm:space-x-2">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="w-full sm:w-auto border-white/20 mb-2 sm:mb-0"
          >
            Cancelar
          </Button>
          <Button
            onClick={onSave}
            className="w-full sm:w-auto bg-clubbers-red hover:bg-clubbers-red/90"
          >
            Guardar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};